export default "__VITE_PUBLIC_ASSET__d3834a1d__"